import "./productList.css";
import Product from "../product/Product";
import { products } from "../../data";

const ProductList = () => {
  return (
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">Come Forward & be the part of family.</h1>
        <h1 className="pl-desc">Top Council Members:</h1>
        <div className="council-members">
          <p>Mr. Alok Upadhyay</p>
          <p>Mr. Karan Sharma </p>
          <p>Ms. Akansha Jain </p>
          <p>Mr. Ashwin Kumar </p>
          <p>Ms. Suhana </p>
        </div>

        <h1 className="pl-title">See What People Say.</h1>
      </div>
      <div className="pl-list">
        {products.map((item) => (
          <Product
            key={item.id}
            img={item.img}
            link={item.link}
            text={item.text}
            name={item.name}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
